import {Component} from '@angular/core';
import {AnalyticsActions} from "../../Redux/Actions/analytics.actions";
import {ActionsService} from "../../Redux/Actions/actions.service";
import {support_to_url} from "../../common/utils";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'edsng-unable-suitable-design',
  templateUrl: './unable-suitable-design.component.html',
  styleUrls: ['./unable-suitable-design.component.css']
})
export class UnableSuitableDesignComponent {

  constructor(private act: ActionsService, public translate: TranslateService) {
  }

  showPage(pageId: string) {
    this.act.sendAction(AnalyticsActions.sendAnalyticsEvent('support_request', pageId, {details: pageId}));
    window.open(support_to_url(pageId, this.translate.currentLang), '_blank');
  }
}
